import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from './header';
import Footer from './footer';
import { AppSidebar, AppSidebarNav, AppFooter } from '@coreui/react';
import { Modal, ModalBody, Button } from 'reactstrap';
// sidebar nav config
import navigation from '../_nav';
// routes config
import routes from '../routes';
import {
  userActions,
  fetchMyKeyword,
  errorActions,
  fetchMyAuthors,
  fetchMyWidgets,
  fetchMyMediaList,
  fetchMyArticles,
  fetchMyDiffusion,
  fetchMyHistoryLog,
} from '../actions';
import { withRouter } from 'react-router-dom';
import { bake_cookie,versionCookie, read_cookie } from '../helpers/cookieHelper';

const mapStateToProps = (state) => {
  return {
    errorCode: state.error.code,
    errorMessage: state.error.message,
    errorOpen: state.error.open,
    errorExpired: state.error.tokenExpired,
    availableWidgets: state.search.availableWidgets.map(obj => obj.id)
  };
};


const mapDispatchToProps = dispatch => {
  return {
    getAll: () => dispatch(userActions.getAll()),
    fetchMyWidgets: () => dispatch(fetchMyWidgets()),
    fetchMyKeyword: () => dispatch(fetchMyKeyword()),
    fetchMyAuthors: () => dispatch(fetchMyAuthors()),
    fetchMyArticles: () => dispatch(fetchMyArticles()),
    fetchMyMediaList: (keepId) => dispatch(fetchMyMediaList(keepId)),
    fetchMyDiffusion: () => dispatch(fetchMyDiffusion()),
    fetchMyHistoryLog: ()=>dispatch(fetchMyHistoryLog()),
    resetError: () => dispatch(errorActions.reset())
  };
};

class MainComponent extends Component {
  constructor() {
    super();
    this.state = {
      navList : navigation,
      availableWidgets: []
    };
  }
  componentDidMount() {
    //  ---------------  初始載入user需要的data  ---------------
    this.props.fetchMyKeyword();
    this.props.fetchMyAuthors();
    this.props.fetchMyArticles();
    this.props.fetchMyWidgets();
    this.props.fetchMyMediaList(true);
    this.props.fetchMyDiffusion();
    this.props.fetchMyHistoryLog();
    this.cookieChecker();
  }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   if(nextProps.availableWidgets.length > 0 && JSON.stringify(nextProps.availableWidgets)!== JSON.stringify(prevState.availableWidgets)){
  //     let preStateNav = prevState.navList.items
  //     let authorityNav = navigation.items.filter(item => item.id !== undefined)

  //     authorityNav.forEach(item =>{
  //       if(item.id){
  //         if(nextProps.availableWidgets.indexOf(item.id) !== -1){
  //           preStateNav.push(item)
  //         }
  //       }
  //     })
  //     return {
  //       ...prevState,
  //       availableWidgets:nextProps.availableWidgets,
  //       navList:{items : preStateNav}
  //     }
  //   }
  //   // if (nextProps.errorCode === 403 || nextProps.errorCode === 401) {
  //   //   nextProps.resetError();
  //   //   nextProps.history.push('/login');
  //   // }
  // }

  cookieChecker =()=>{
    const version = read_cookie(versionCookie)
    if(!version){
      bake_cookie(versionCookie,{verlist:[]})
    }
  }

  closeError = () => {
    if (this.props.errorExpired) {
      this.props.history.push('/login');
    }
    else {
      this.props.resetError();
    }
  }

  render() {
    // the hostname of this site

    const domainname = window.location.hostname;
    console.log('this website is host in => ', domainname)
    return (
      <div className="app lowi-v3">
        <Header />
        <div className="app-body">
          <AppSidebar fixed display="lg" minimized>
            <AppSidebarNav navConfig={this.state.navList} {...this.props} />
          </AppSidebar>
          <main className="main">
            <Switch>
              {routes.map((route, idx) => {
                return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (<route.component {...props} />)} />)
                  : (null);
              },
              )}
              <Redirect from="/" to="/workspace" />
            </Switch>
            <Modal size='mid' isOpen={this.props.errorOpen} toggle={this.closeError}>
              <ModalBody>
                <div className='error-content'>{this.props.errorExpired ? '連線逾時，將導向登入頁面，請重新登入後再進行操作。' : this.props.errorMessage}</div>
                <div className='error-button'><Button onClick={this.closeError}>確定</Button></div>
              </ModalBody>
            </Modal>
          </main>
        </div>
        <AppFooter>
          <Footer />
        </AppFooter>
      </div>
    );
  }
}

const Main = connect(mapStateToProps, mapDispatchToProps)(MainComponent);

export default withRouter(Main);



// WEBPACK FOOTER //
// ./src/components/Main.js